export default __webpack_public_path__ + "static/media/close.3c232064.svg";